import Button from "@edaz/edazkit/Button/index";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import React from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault, registerView } from "@frui.ts/views/dist";
import CreateExemptionViewModel from "viewModels/callCenter/search/exemptions/createExemption/createExemptionViewModel";
import CreateExemptionFormSection from "./createFormSection";
import CreateExemptionPreviewSection from "./createPreviewSection";

const CreateExemptionView: ViewComponent<CreateExemptionViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  return (
    <Modal show={true} onHide={vm.onClose} centered>
      <Modal.Header closeButton={true}>
        <Modal.Title>{vm.translate("name")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          <Form onSubmit={preventDefault(vm.onSave)}>
            {vm.creationStep === 1 && <CreateExemptionFormSection vm={vm} />}
            {vm.creationStep === 2 && <CreateExemptionPreviewSection vm={vm} />}
            <ButtonToolbar className="justify-content-center">
              {vm.creationStep === 2 ? (
                <Button size="sm" onClick={vm.onBack} variant="light">
                  {vm.translateGeneral("back")}
                </Button>
              ) : (
                <Button size="sm" type="reset" onClick={vm.onClose} variant="light">
                  {vm.translateGeneral("cancel")}
                </Button>
              )}

              <Button size="sm" type="submit" disabled={vm.isContinueDisabled()}>
                {vm.creationStep === 2 ? vm.translateGeneral("confirm") : vm.translateGeneral("continue")}
              </Button>
            </ButtonToolbar>
          </Form>
        </LoaderOverlay>
      </Modal.Body>
    </Modal>
  );
});

registerView(CreateExemptionView, CreateExemptionViewModel);
